import React from "react";
import {
  Box,
  Button,
  Chip,
  Container,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { featuredProjects } from "../../config/projects";
import "../../styles/components/ProjectsSection.css";

function ProjectsSection() {
  const navigate = useNavigate();

  return (
    <section className="home-projects-section">
      <Container>
        <Box className="home-projects-header">
          <Box>
            <Typography variant="h3" component="h2" sx={{ fontWeight: 700 }}>
              Featured Work
            </Typography>
            <Typography color="text.secondary" sx={{ mt: 1, maxWidth: 620 }}>
              A snapshot of the development areas I focus on, from polished
              interfaces to backend integrations.
            </Typography>
          </Box>
          <Button
            variant="outlined"
            endIcon={<ArrowForward />}
            onClick={() => navigate("/projects")}
          >
            View Projects
          </Button>
        </Box>

        <Grid
          container
          rowSpacing={{ xs: 2, md: 3 }}
          columnSpacing={{ xs: 0, md: 3 }}
        >
          {featuredProjects.map((project) => (
            <Grid item xs={12} md={4} key={project.title}>
              <Paper className="home-project-card" elevation={1}>
                <div
                  className="home-project-card-accent"
                  style={{ backgroundColor: project.accent }}
                />
                <Typography
                  variant="overline"
                  component="p"
                  sx={{ color: project.accent, fontWeight: 700 }}
                >
                  {project.category}
                </Typography>
                <Typography
                  variant="h5"
                  component="h3"
                  sx={{
                    fontWeight: 700,
                    lineHeight: 1.25,
                    overflowWrap: "anywhere",
                  }}
                >
                  {project.title}
                </Typography>
                <Typography color="text.secondary" sx={{ mt: 2, lineHeight: 1.7 }}>
                  {project.summary}
                </Typography>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 3 }}>
                  {project.stack.slice(0, 3).map((item) => (
                    <Chip key={item} label={item} size="small" />
                  ))}
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </section>
  );
}

export default ProjectsSection;
